<template>
  <container :class="['h-three']">
    <h3 v-html="title || $lang.genericExamplesTitle" :class="['my-3']" />
    <divider v-if="divider" :class="['mb-3']" />
  </container>
</template>
<script>
export default {
  name: 'HThree',
  props: {
    title: {
      type: String
    },
    divider: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/h-three.vue